import PriceListItem from "@components/PriceListItem/PriceListItem";
import styles from "./PriceList.module.scss";
import classNames from "classnames";
import React from "react";
import { useTranslations } from "next-intl";
import PriceListAdditionalItem from "@components/PriceListAdditionalItem/PriceListAdditionalItem";
function PriceList({ className, ...props }) {
    const t = useTranslations("CompanySolutionsPage");
    const priceListItems = [
        {
            cardItem: 1,
            title: "Kveikja",
            price: "19.900",
            price2: "12.900",
            highlighted: true,
            bottomCopy: "Taktu fyrstu skrefin með 120+ aðgerðum.",
            ctaLabel: "Byrja frítt →",
            ctaHref: "https://admin.laufid.is/registration",
            ctaStyle: "outline",
            descriptionList: [
                { included: true, copy: "120+ aðgerðir" },
                { included: true, copy: "Laufaskólinn / Fræðsla" },
                { included: true, copy: "Kolefnisreiknir" },
                { included: true, copy: "Markmið og aðgerðaáætlun" },
                { included: false, copy: "Birgjamat" },
                { included: false, copy: "Skýrslur og samanburður" },
                { included: false, copy: "Kolka raungögn" },
            ],
        },
        {
            cardItem: 2,
            title: "Vaxa",
            price: "34.900",
            price2: "19.900",
            badge: "Vinsælastur",
            highlighted: true,
            bottomCopy: "Sýndu árangur — skýrslur, birgjamat og kannanir.",
            ctaLabel: "Hefja áskrift →",
            ctaHref: "https://admin.laufid.is/registration",
            ctaStyle: "primary",
            descriptionList: [
                { included: true, copy: "Allt í Kveikja" },
                { included: true, copy: "Birgjamat" },
                { included: true, copy: "Heimsmarkmiðin" },
                { included: true, copy: "Skýrslur og samanburður" },
                { included: true, copy: "Starfsmannakannanir" },
                { included: false, copy: "Kolka raungögn" },
                { included: false, copy: "HR mælaborð" },
            ],
        },
        {
            cardItem: 3,
            title: "Efla",
            price: "74.900",
            price2: "59.900",
            badge: "Mælt með",
            highlighted: true,
            promoted: true,
            bottomCopy: "Raungögn, HR og eigna-app — allt innifalið.",
            ctaLabel: "Hefja áskrift →",
            ctaHref: "https://admin.laufid.is/registration",
            ctaStyle: "primary",
            descriptionList: [
                { included: true, copy: "Allt í Vaxa" },
                { included: true, copy: "Kolka raungögn (innifalin)" },
                { included: true, copy: "Eigna-app / fasteignir" },
                { included: true, copy: "HR mælaborð" },
                { included: true, copy: "Ítarlegur kolefnisútreikningur" },
                { included: true, copy: "Sóunargreining" },
                { included: true, copy: "Sérstakur tengiliður" },
            ],
        },
        {
            cardItem: 4,
            title: "Dafna",
            price: "frá 149.900",
            price2: "134.900",
            highlighted: true,
            bottomCopy: "Heildstætt stjórnkerfi fyrir stór fyrirtæki.",
            ctaLabel: "Hafa samband",
            ctaHref: "mailto:hallo@laufid.is",
            ctaStyle: "dark",
            descriptionList: [
                { included: true, copy: "Allt í Efla" },
                { included: true, copy: "Gæðastjórnunarkerfi" },
                { included: true, copy: "Eignastjórnun (bílar, tæki)" },
                { included: true, copy: "Kolefnisbókhald (Scope 1/2/3)" },
                { included: true, copy: "Stofnanastjórnun" },
                { included: true, copy: "Heimsmarkmiðin (SDG)" },
                { included: true, copy: "CSRD/ESRS (haust 2026)" },
            ],
        },
    ];
    const priceListAdditionalItems = [
        {
            title: "Umhverfisstefna",
            price: "290.000 kr.",
            description:
                "Skýr og hagnýt stefna sem uppfyllir lög og reglur um umhverfismál. Sjálfstæð þjónusta sem má samþætta hvaða pakka eða lausn sem er.",
            icon: (
                <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                    <polyline points="14 2 14 8 20 8" />
                    <line x1="16" y1="13" x2="8" y2="13" />
                    <line x1="16" y1="17" x2="8" y2="17" />
                </svg>
            ),
        },
        {
            title: "Sjálfbærnistefna",
            price: "290.000 kr.",
            description:
                "Heildstæð stefna sem sameinar umhverfis-, félagslega og stjórnarlega þætti (ESG). Sjálfstæð þjónusta sem má samþætta hvaða pakka eða lausn sem er.",
            icon: (
                <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <circle cx="12" cy="12" r="10" />
                    <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" />
                    <path d="M2 12h20" />
                </svg>
            ),
        },
        {
            title: "Vinnustofa",
            price: "frá 49.000 kr.",
            description:
                "Hagnýt fræðsla og stefnumótun fyrir stjórnendur og starfsfólk. Lögð áhersla á virkni og raunhæfar aðgerðir.",
            icon: (
                <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                    <circle cx="9" cy="7" r="4" />
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                </svg>
            ),
        },
        {
            title: "Ráðgjöf",
            price: "14.900 kr./klst.",
            description:
                "Sérsniðin ráðgjöf sem tekur mið af umfangi, stöðu og markmiðum hvers fyrirtækis.",
            icon: (
                <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                </svg>
            ),
        },
    ];

    return (
        <div className={classNames(styles.container, className)} {...props}>
            <div className={styles.pricingGrid}>
                {priceListItems.map((item) => (
                    <PriceListItem key={item.title} {...item} />
                ))}
            </div>

            <p className={styles.bottomLegal}>
                Öll verð eru án vsk. en *fræðslustyrkur frá
                starfsmenntunarsjóðum geta lækkað áskriftarverðið. Hluti af
                þjónustu Laufsins fellur undir fræðslu og þjálfun starfsfólks.
                Því geta fyrirtæki sem eru aðilar að Samtökum atvinnulífsins eða
                Félagi atvinnurekenda fengið allt að helming kostnaðar
                endurgreiddan úr starfsmenntasjóði í gegnum Áttina – eina
                sameiginlega umsókn fyrir alla helstu sjóði.
            </p>

            <div className={styles.additionalSection}>
                <h3 className={styles.additionalTitle}>
                    Viðbótarþjónusta Laufins
                </h3>
                <p className={styles.additionalSubtitle}>
                    Fyrirtæki geta bætt við sérverkefnum og ráðgjöf sem styðja
                    við sjálfbærnivegferðina og styrkja innviði rekstrarins.
                </p>
                <div className={styles.additionalGrid}>
                    {priceListAdditionalItems.map((item) => (
                        <PriceListAdditionalItem key={item.title} {...item} />
                    ))}
                </div>
            </div>
        </div>
    );
}

export default PriceList;
